import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { SEO, SITE_DOMAIN } from "@/seo";

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Single mounted component that keeps <head> SEO in sync with the route + language.
const Seo = () => {
  const { pathname } = useLocation();
  const { lang } = useApp();

  useEffect(() => {
    const entry = (SEO[pathname] || SEO["/"])[lang];
    const url = `${SITE_DOMAIN}${pathname === "/" ? "/" : pathname}`;
    const isAdmin = pathname.startsWith("/admin");

    document.title = entry.title;
    setMeta('meta[name="description"]', "name", "description", entry.desc);
    setMeta('meta[property="og:title"]', "property", "og:title", entry.title);
    setMeta('meta[property="og:description"]', "property", "og:description", entry.desc);
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    setMeta('meta[property="og:locale"]', "property", "og:locale", lang === "ar" ? "ar_SA" : "en_US");
    setLink("canonical", url);

    // Keep /admin out of search indexes
    setMeta('meta[name="robots"]', "name", "robots", isAdmin ? "noindex, nofollow" : "index, follow");
  }, [pathname, lang]);

  return null;
};

export default Seo;
